import axios from 'axios';

const baseURL = `${process.env.VUE_APP_API_BASE}`;

const repository = axios.create({
    baseURL,
});

repository.interceptors.response.use(res => res, error => {
    const message = error.response?.data?.message;
    if (Array.isArray(message)) {
        error.message = message.join(', ');
    } else if (!message) {
        error.message = '알 수 없는 에러가 발생했습니다.';
    } else {
        error.message = message;
    }
    return Promise.reject(error);
});

export default repository;